import { render } from "./save-item-modal.vue?vue&type=template&id=088c7682"
import script from "./save-item-modal.vue?vue&type=script&lang=js"
export * from "./save-item-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__